window.addEventListener('load', function() {

  document.querySelectorAll('.rating[data-lazyload]').forEach(function(el) {
    var url = el.getAttribute('data-lazyload');

    fetch(url).then(function(response) {
      return response.json();
    }).then(function(json) {
      var score = el.querySelector('.score');
      var stars = el.querySelector('.empty-stars .stars');
      var total = el.querySelector('.total');

      score.textContent = json['score'];

      stars.style['width'] = json['width'];
      stars.setAttribute('data-rating', json['average_rating']);

      total.textContent = json['total'];
    });

    el.removeAttribute('data-lazyload');
  });

  document.querySelectorAll('img').forEach(function(el) {
    var p = el.parentNode;
    if (p.childNodes.length === 1 && p.tagName === 'P') {
      p.classList.add('only-image');
    } else {
      p.classList.add('with-image');
    }
  });

});
